import LegalLayout from '../LegalLayout';

export default function Security() {
  return (
    <LegalLayout title="Безопасность данных" updatedAt="24 апреля 2026 года">
      <p>
        Этот документ описывает технические и&nbsp;организационные меры, которые мы
        применяем для защиты данных Заказчиков и&nbsp;гостей. Документ носит
        информационный характер; полные обязательства приведены в&nbsp;
        <a href="/legal/privacy">Политике конфиденциальности</a>.
      </p>

      <h2>1. Где находятся данные</h2>
      <ul>
        <li>Все базы данных и&nbsp;файловое хранилище размещены на&nbsp;серверах в&nbsp;Российской Федерации.</li>
        <li>Трансграничная передача персональных данных не&nbsp;осуществляется.</li>
        <li>Бэкапы хранятся в&nbsp;отдельном регионе того&nbsp;же провайдера для отказоустойчивости.</li>
      </ul>

      <h2>2. Шифрование</h2>
      <ul>
        <li>Транспортный уровень: TLS&nbsp;1.3, HSTS включён;</li>
        <li>Пароли пользователей: bcrypt с&nbsp;индивидуальной солью;</li>
        <li>Платёжные данные: не&nbsp;хранятся, токенизация на&nbsp;стороне ЮKassa (PCI&nbsp;DSS).</li>
      </ul>

      <h2>3. Контроль доступа</h2>
      <ul>
        <li>Принцип наименьших привилегий для всех внутренних ролей;</li>
        <li>Двухфакторная аутентификация для административного доступа;</li>
        <li>Аудит входа и&nbsp;действий в&nbsp;административных интерфейсах;</li>
        <li>Ограничение доступа к&nbsp;инфраструктуре по&nbsp;IP&nbsp;и&nbsp;через VPN.</li>
      </ul>

      <h2>4. Резервное копирование</h2>
      <ul>
        <li>Полный бэкап БД: ежедневно;</li>
        <li>Точечное восстановление (point-in-time) на&nbsp;любую минуту последних 7&nbsp;дней;</li>
        <li>Ежемесячное тестирование процедуры восстановления.</li>
      </ul>

      <h2>5. Мониторинг и&nbsp;реагирование</h2>
      <ul>
        <li>Автоматический мониторинг ошибок приложения без передачи персональных данных;</li>
        <li>Метрики доступности и&nbsp;времени отклика 24/7;</li>
        <li>Регламент реагирования на&nbsp;инциденты с&nbsp;уведомлением Роскомнадзора в&nbsp;течение 24&nbsp;часов с&nbsp;момента обнаружения нарушения, как этого требует 152-ФЗ в&nbsp;редакции 2025&nbsp;года.</li>
      </ul>

      <h2>6. Безопасность кода</h2>
      <ul>
        <li>Зависимости проверяются автоматически на&nbsp;известные CVE;</li>
        <li>Code review для всех изменений в&nbsp;продакшен-коде;</li>
        <li>Защита от&nbsp;распространённых уязвимостей OWASP&nbsp;Top&nbsp;10 (XSS, CSRF, SQLi, SSRF, IDOR).</li>
      </ul>

      <h2>7. Ответственное раскрытие уязвимостей</h2>
      <p>
        Если вы&nbsp;обнаружили уязвимость в&nbsp;Сервисе, пожалуйста, сообщите нам
        до&nbsp;её&nbsp;публичного раскрытия. Мы&nbsp;ценим вашу работу и&nbsp;разберёмся
        в&nbsp;течение 5&nbsp;рабочих дней.
      </p>
      <ul>
        <li>Email: <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a> с&nbsp;темой «Security»;</li>
        <li>Если уязвимость критическая, пометьте письмо «URGENT»;</li>
        <li>Не&nbsp;используйте уязвимость для доступа к&nbsp;чужим данным, достаточно демонстрации возможности.</li>
      </ul>
      <p>
        Мы&nbsp;не&nbsp;инициируем юридическое преследование исследователей, действующих
        добросовестно в&nbsp;рамках этой политики.
      </p>

      <h2>8. Удаление данных при расторжении</h2>
      <p>
        После расторжения договора учётная запись и&nbsp;связанные данные удаляются
        в&nbsp;течение 6&nbsp;месяцев. Данные о&nbsp;расчётах, которые мы&nbsp;обязаны
        хранить по&nbsp;закону (54-ФЗ, налоговый учёт), сохраняются на&nbsp;установленный
        законом срок.
      </p>

      <h2>9. Контакты</h2>
      <p>
        Любые вопросы по&nbsp;безопасности:{' '}
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>.
      </p>
    </LegalLayout>
  );
}
